// extracted by mini-css-extract-plugin
export default {"Tabs":"styles_Tabs__9ng51","tabsContainer":"styles_tabsContainer__i9zgn","line":"styles_line__VSDH9","lineFill":"styles_lineFill__mGSaS"};